<a *ngIf="href" class="link-button" [attr.data-variant]="variant" [attr.data-size]="size"
  [attr.data-disabled]="disabled" [href]="disabled ? null : href" [target]="target"
  [attr.aria-label]="computedAriaLabel" [attr.aria-disabled]="disabled" (click)="onLinkClick($event)">
  
  <!-- Left Icon -->
  <span class="icon-wrapper left-icon" *ngIf="showLeftIcon" aria-hidden="true">
    <umss-icon [name]="leftIconName!" [size]="computedIconSize" [color]="iconColor"></umss-icon>
  </span>

  <!-- Link text -->
  <span class="button-text">{{ label }}</span>

  <!-- Right Icon -->
  <span class="icon-wrapper right-icon" *ngIf="showRightIcon" aria-hidden="true">
    <umss-icon [name]="rightIconName!" [size]="computedIconSize" [color]="iconColor"></umss-icon>
  </span>
</a>

<button *ngIf="!href" class="link-button" [attr.data-variant]="variant" [attr.data-size]="size"
  [attr.data-disabled]="disabled" [disabled]="disabled" [attr.aria-label]="computedAriaLabel"
  (click)="onButtonClick($event)" type="button">
  
  <!-- Left Icon -->
  <span class="icon-wrapper left-icon" *ngIf="showLeftIcon" aria-hidden="true">
    <umss-icon [name]="leftIconName!" [size]="computedIconSize" [color]="iconColor"></umss-icon>
  </span>

  <!-- Button text -->
  <span class="button-text">{{ label }}</span>

  <!-- Right Icon -->
  <span class="icon-wrapper right-icon" *ngIf="showRightIcon" aria-hidden="true">
    <umss-icon [name]="rightIconName!" [size]="computedIconSize" [color]="iconColor"></umss-icon>
  </span>
</button>